'use strict';
define('elements/sidebar--blog',['stickyfill', 'jquery'], function(Stickyfill, $) {
    var stickyElements = document.getElementsByClassName('sidebar-blog');
    for(var i = stickyElements.length - 1; i >= 0; i--) {
        Stickyfill.add(stickyElements[i]);
    }
});
